import { render, staticRenderFns } from "./DocumentsReports.vue?vue&type=template&id=0eccf49f&scoped=true&"
import script from "./DocumentsReports.vue?vue&type=script&lang=ts&"
export * from "./DocumentsReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eccf49f",
  null
  
)

export default component.exports